"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var User_exports = {};
__export(User_exports, {
  default: () => User_default
});
module.exports = __toCommonJS(User_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.2852 9.72266C11.2487 9.72266 12.069 9.38411 12.7461 8.70703C13.4362 8.01693 13.7812 7.1901 13.7812 6.22656C13.7812 5.27604 13.4362 4.46224 12.7461 3.78516C12.069 3.09505 11.2487 2.75 10.2852 2.75C9.33464 2.75 8.51432 3.09505 7.82422 3.78516C7.14714 4.46224 6.80859 5.27604 6.80859 6.22656C6.80859 7.1901 7.14714 8.01693 7.82422 8.70703C8.51432 9.38411 9.33464 9.72266 10.2852 9.72266ZM10.2852 3.84375C10.9492 3.84375 11.5091 4.07812 11.9648 4.54688C12.4336 5.01562 12.668 5.57552 12.668 6.22656C12.668 6.89062 12.4336 7.45703 11.9648 7.92578C11.5091 8.39453 10.9492 8.62891 10.2852 8.62891C9.63411 8.62891 9.07422 8.39453 8.60547 7.92578C8.14974 7.45703 7.92188 6.89062 7.92188 6.22656C7.92188 5.57552 8.14974 5.01562 8.60547 4.54688C9.07422 4.07812 9.63411 3.84375 10.2852 3.84375ZM12.8438 11.207H7.80469C7.25781 11.207 6.74349 11.3112 6.26172 11.5195C5.77995 11.7148 5.35677 11.9883 4.99219 12.3398C4.64062 12.6784 4.36068 13.082 4.15234 13.5508C3.94401 14.0195 3.83984 14.5143 3.83984 15.0352V16.3633C3.83984 16.5195 3.89193 16.6497 3.99609 16.7539C4.10026 16.8581 4.23047 16.9102 4.38672 16.9102C4.52995 16.9102 4.65365 16.8581 4.75781 16.7539C4.875 16.6497 4.93359 16.5195 4.93359 16.3633V15.0352C4.93359 14.2799 5.21354 13.6419 5.77344 13.1211C6.33333 12.5872 7.01042 12.3203 7.80469 12.3203H12.8438C13.625 12.3203 14.2956 12.5872 14.8555 13.1211C15.4284 13.6419 15.7148 14.2799 15.7148 15.0352V16.3633C15.7148 16.5195 15.7669 16.6497 15.8711 16.7539C15.9753 16.8581 16.1055 16.9102 16.2617 16.9102C16.4049 16.9102 16.5286 16.8581 16.6328 16.7539C16.75 16.6497 16.8086 16.5195 16.8086 16.3633V15.0352C16.8086 14.5143 16.7044 14.0195 16.4961 13.5508C16.2878 13.082 16.0013 12.6784 15.6367 12.3398C15.2852 11.9883 14.8685 11.7148 14.3867 11.5195C13.9049 11.3112 13.3906 11.207 12.8438 11.207Z",
      fill: "currentColor"
    }
  )
);
const SvgUser = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var User_default = SvgUser;
